import {DataFetcher} from '@aboutyou/data-fetcher';
import React, {useEffect} from 'react';
import {useSizesSection} from '../useGetProductBulkSection';
import {AddToBasketQuickViewLoading} from './AddToBasketQuickViewLoading';
import {
  AddToBasketQuickViewView,
  AddToBasketQuickViewViewProps,
} from './AddToBasketQuickViewView';

export const AddToBasketQuickView: React.FC<
  AddToBasketQuickViewViewProps
> = props => {
  // reset selected size when the product data is refreshed (after being stale)
  // and only if the selected size is soldOut
  useEffect(() => {
    if (props.selectedSize?.availability?.$case === 'soldOut') {
      props.setSelectedSize(undefined);
    }
  }, [props.selectedSize, props.selectedSize?.availability?.$case]);

  return (
    <DataFetcher
      request={useSizesSection({
        currentSize: {
          selectedSize: props.selectedSize,
          setSelectedSize: props.setSelectedSize,
        },
      })}
      Error={null}
      Loading={() => (
        <AddToBasketQuickViewLoading className={props.className} />
      )}
      View={AddToBasketQuickViewView}
      viewProps={props}
    />
  );
};
